export function getMarketplaceBackend() {
    return import.meta.env.VITE_MARKETPLACE_BACKEND_URL;
}

export function getMarketplaceEuBackend() {
    return import.meta.env.VITE_MARKETPLACE_EU_LOAD_BALANCER_URL;
}
